export default {
  SET_PRODUCT(state, payload) {
    state.productDetails = payload;
  },
  SET_ALLPRODUCT(state, payload) {
    state.allProductDetails = payload;
    state.productDetails = payload.result;
    state.totalRowsState = payload.totalCount;
  },
  SET_CURRENTPAGESTATE(state, payload) {
    state.currentPageState = payload;
  },
  SET_SEARCHSTATE(state, payload) {
    state.searchState = payload;
  },
  // SET_TOTALROWSSTATE(state, payload) {
  //   state.totalRowsState = payload;
  // },
};
